import React from "react";

export default function About() {
  return (
    <div className="my-8 px-4 container mx-auto">
      <h1 className="text-center text-3xl font-bold mb-6">About Us</h1>
      <p className="mb-4">
        17 years with you! In the 17 years we have been with you, our idea and objective have not changed – we work hard and try to make sure our clients can easily receive items without overpaying for them.
      </p>
      <p className="mb-4">
        No need to wait. We already have all of the listed items in stock. We gladly welcome you to visit our demonstration studio where you can interact with all the items that interest you and, if needed, receive a consultation from one of our specialists. We are confident that with this approach we will make your decision easier and your day a bit better.
      </p>
      <p className="mb-4">
        We are proud of what we have achieved so far and, thanks to the positive reviews from our clients, are continuing to evolve and grow.
      </p>
      <p className="mb-4">
        From only just starting out gamers all the way to world-class cyber athletes, we welcome all manner of computer enthusiasts into our store!
      </p>
      <blockquote className="italic mb-4">
        “Individual approach for every client”; “Compromise in different situations”; “Quality service”
      </blockquote>
      <p className="mb-4">
        These are standard phrases you will find on any online store's “About us’’ page. We will not manipulate you by using tired and overused phrases. Instead, we will tell you who we are and why we are here and introduce you to our goals.
      </p>
      <p className="mb-4">
        Instead of looking for competitors, we prefer to focus on our goals. A separate demonstration studio, high item quality, a wide range of items to choose from, and excellent prices – these are the main factors that influence a client's opinion of us.
      </p>
      <p className="mb-4">
        ... specializes in gaming peripherals from the most popular brands on the market, for instance, Razer, Steelseries, DxRacer, HyperX, Logitech, Corsair, Glorious PC Gaming Race, Elgato, Zowie By Benq, Dark Project, Varmillo, VGN, Lamzu, Fifine and others. Our shelves are regularly updated with items from new manufacturers.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-2">Our Achievements</h2>
      <p className="mb-4">
        Understanding how important cybersport growth is, ... has sponsored more than 100 cybersport tournaments in different Baltic regions.
      </p>
      <p className="mb-4">
        As to not have an endless list here, we will be adding only ongoing or future tournaments to which we have a direct relation.
      </p>
      <p className="mb-4">
        <strong>FORMULA 1 – LatviaRacingLeague</strong>
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-2">Our Products</h2>
      <p className="mb-4">
        Elegant and professional gaming hardware for real gamers – a strong weapon to help achieve victory in cybersports.
      </p>
      <p className="mb-4">
        ... offers items that are compliant with industry standards. All items that you can see in our store are delivered directly from the manufacturer. This gives a guarantee that the item you receive is completely authentic and original. To make it easier for our clients to find what they are looking for, we have added dedicated pages for news, item specifications, and item descriptions, as well as a separate item filter.
      </p>
      <p className="mb-4">
        Our educated managers are ready to help you decide on which item to buy and to answer any questions that you may have.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-2">Become a ... Partner</h2>
      <p className="mb-4">
        Strength and motivation come from support. That is why we are ready to support you in your first steps. We are always happy to meet new streamers, reviewers, and let’s players. The ... team will provide you with the necessary support in all of your endeavors, help with solving difficult situations, and will be there for you.
      </p>
      <p className="mb-4">
        We have no competitors and are always open to any kind of collaboration. All you have to do is reach out to us – <a className="text-blue-600 underline" href="mailto:eriks@transparent.lv">eriks@transparent.lv</a>.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-2">Always Open to Communication</h2>
      <p className="mb-4">
        ... managers are always ready to answer any questions that you may have.
      </p>
      <p className="mb-4">
        Don't be shy and contact us by calling <a className="text-blue-600 underline" href="tel:+37122164949">+371 22164949</a> or by writing to <a className="text-blue-600 underline" href="mailto:4games@4games.lv">4games@4games.lv</a> to ask for professional advice, receive guidance if you are unsure about an item, or receive technical assistance.
      </p>
      <p className="mb-4">
        Thanks to our active Facebook and Instagram accounts, you can reach us 24/7.
      </p>
      <p className="mb-4">
        Every day a new post! Each day we have a new post where we highlight the newest additions to our stock, jokes, and funny videos.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-2">Thank You for Your Trust!</h2>
      <p className="mb-4">
        The ... team would like to extend a very sincere thank you to all of our customers! Thank you for staying with us and believing in us! It is only thanks to your support that we can keep growing!
      </p>
      <p className="mb-4">
        Of course, we physically can’t thank you all in person, as there are so many of you!
      </p>
      <p className="mb-4">
        This is why, as a thank you to all of our beloved clients, we regularly hold <strong>#giveaway</strong> contests on our social media platforms, where you have the chance to win the newest and coolest peripherals.
      </p>
    </div>
  );
}
